import type { ReactNode } from 'react';

export type KpiSeverity = 'default' | 'urgent' | 'warn' | 'approvals' | 'balance' | 'cust' | 'rev';
export type KpiDeltaDir = 'up' | 'down' | 'flat';

export interface KpiTileProps {
  label: string;
  value: string | number;
  severity?: KpiSeverity;
  delta?: {
    dir: KpiDeltaDir;
    text: string;
  };
  /** SVG polyline points (optional sparkline). */
  sparkline?: ReactNode;
  drillLink?: ReactNode;
}

/** Primitive 12: KPI tile (RPM/RRM/dashboard hero). */
export function KpiTile({
  label,
  value,
  severity = 'default',
  delta,
  sparkline,
  drillLink,
}: KpiTileProps): JSX.Element {
  const severityClass = severity === 'default' ? '' : `kpi-tile--${severity}`;
  return (
    <div className={`kpi-tile ${severityClass}`.trim()}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
        <span className="kpi-tile__label">{label}</span>
        {drillLink && <span style={{ fontSize: 11 }}>{drillLink}</span>}
      </div>
      <span className="kpi-tile__value" style={severity === 'urgent' ? { color: 'var(--pcb-red)' } : undefined}>
        {value}
      </span>
      <div className="kpi-tile__bottom">
        {delta && (
          <span style={{ color: delta.dir === 'up' ? 'var(--pcb-green)' : delta.dir === 'down' ? 'var(--pcb-red)' : 'var(--ink-500)' }}>
            {delta.dir === 'up' ? '↑' : delta.dir === 'down' ? '↓' : '→'} {delta.text}
          </span>
        )}
        {sparkline}
      </div>
    </div>
  );
}
